import { render, staticRenderFns } from "./editRoleDialog.vue?vue&type=template&id=c8014984&scoped=true"
import script from "./editRoleDialog.vue?vue&type=script&lang=js"
export * from "./editRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8014984",
  null
  
)

export default component.exports